import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { API_HANDLERS } from 'api/apiHandlers';
import { alert } from 'components';

export function useDeleteFolderMutation() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const { mutateAsync: deleteFolderMutation, isLoading } = useMutation(
    (id: string) => API_HANDLERS.FOLDERS.DELETE(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['folders']);
        queryClient.invalidateQueries(['files']);
        alert.success(t('toasts.folder.success.remove'));
      },
    },
  );

  return { deleteFolderMutation, isLoading };
}
